import React, { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '~/components/Icon';
import { signOutRequest } from '~/store/modules/auth/actions';
import images from '~/constants/images';
import { AddLogoModalContent, PopUpView, Link, FoldedMenu } from '~/components';
import { languageOptions } from '~/utils/languageOptions';
import { HeaderContext } from '~/context';
import EditUser from '~/pages/EditUser';
import EditPassword from '~/pages/EditPassword';
import { azureLogout } from '~/services/api';
import * as S from '../styles';
import { propTypes, defaultProps } from './propsValidation';

export default function Header({ user, dispatch, title }) {
  const { t } = useTranslation();
  const [showModal, setModalVisibility] = useState(false);
  const [showMenu, setModalMenuVisibility] = useState(false);
  const { headerProps } = useContext(HeaderContext);

  const buttonRight =
    headerProps && headerProps.buttonRight ? headerProps.buttonRight : null;
  const buttonLeft =
    headerProps && headerProps.buttonLeft ? headerProps.buttonLeft : null;
  return (
    <S.Header>
      <S.HeaderBackground />
      {buttonLeft && <S.ShowMenu>{buttonLeft}</S.ShowMenu>}
      {!buttonLeft && (
        <>
          <S.ShowMenu
            onClick={() => {
              setModalMenuVisibility(!showMenu);
              setModalVisibility(false);
            }}
          >
            {showMenu ? (
              <Icon name="close" size={19} color="black" />
            ) : (
              <Icon name="menu" size={19} color="black" />
            )}
          </S.ShowMenu>
        </>
      )}
      <S.LaLigaLogo src={images.logoWhiteHorizontal} />
      {user.logo && user.logo.filePath && (
        <S.BrandLogo src={user.logo.filePath} />
      )}
      <S.AppName>
        {title.toUpperCase() || t('appNameShort').toUpperCase()}
      </S.AppName>
      <PopUpView isOpen={showMenu} zone="left" fullWidth>
        {!showModal && (
          <S.MenuMobileContainer>
            <div>
              <Link to="/">
                {t('dashboard')}
                <Icon name="chevronRight" size={12} color="coral" />
              </Link>
              <S.Separator />
              {!user.laliga && (
                <>
                  <div
                    role="button"
                    tabIndex={0}
                    className="link"
                    onClick={() => setModalVisibility('editLogo')}
                    onKeyDown={() => setModalVisibility(!showModal)}
                  >
                    {t('changeLogo')}
                    <Icon name="chevronRight" size={12} color="coral" />
                  </div>
                  <S.Separator />
                  <div
                    role="button"
                    tabIndex={0}
                    className="link"
                    onClick={() => setModalVisibility('editUser')}
                    onKeyDown={() => setModalVisibility(!showModal)}
                  >
                    {t('editAccount')}
                    <Icon name="chevronRight" size={12} color="coral" />
                  </div>
                  <S.Separator />
                  <div
                    role="button"
                    tabIndex={0}
                    className="link"
                    onClick={() => setModalVisibility('editPassword')}
                    onKeyDown={() => setModalVisibility(!showModal)}
                  >
                    {t('editPassword')}
                    <Icon name="chevronRight" size={12} color="coral" />
                  </div>
                  <S.Separator />
                </>
              )}
              <div
                role="button"
                className="link"
                tabIndex={0}
                onClick={async () => {
                  dispatch(signOutRequest());
                  if (user.laliga) await azureLogout();
                }}
                onKeyDown={() => setModalVisibility(!showModal)}
              >
                {t('logout')}
                <Icon name="chevronRight" size={12} color="coral" />
              </div>
            </div>
            <FoldedMenu
              label={t('languageId')}
              options={languageOptions()}
              invert
            />
          </S.MenuMobileContainer>
        )}
        {showModal === 'editLogo' && (
          <S.ContainerScrollbar>
            <AddLogoModalContent closeModal={() => setModalVisibility(false)} />
          </S.ContainerScrollbar>
        )}
        {showModal === 'editPassword' && (
          <EditPassword
            onClose={() => setModalVisibility(false)}
            onSubmit={() => setModalVisibility(false)}
          />
        )}
        {showModal === 'editUser' && (
          <S.ContainerScrollbar>
            <EditUser
              onSubmit={() => setModalVisibility(false)}
              onClose={() => setModalVisibility(false)}
            />
          </S.ContainerScrollbar>
        )}
      </PopUpView>
      {buttonRight && (
        <>
          <S.Grow />
          {buttonRight}
        </>
      )}
    </S.Header>
  );
}

Header.propTypes = propTypes;

Header.defaultProps = defaultProps;
